module.exports = __webpack_public_path__ + "static/media/edit.a91e066d.svg";